import { Slider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { getValueLabelFormat } from '../utils/formatter';

const useStyles = makeStyles((theme) => ({
  relativeScaleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: 'auto',
    marginLeft: 'auto',
  },
  relativeScaleLabel: {
    whiteSpace: 'nowrap',
  },
  sliderWrapper: {
    width: 200,
  },
  scaleBadge: {
    backgroundColor: theme.palette.grey[400],
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.75rem',
    fontWeight: 500,
    minWidth: 60,
    textAlign: 'center',
  },
}));

const RelativeScaleSlider = ({ mappingParam, paramConfig, onScaleChange, disabled, configSwitchLabel, param='shape' }) => {
  const classes = useStyles();
  const [scale, setScale] = useState(undefined);

  useEffect(() => {
    const enabledChildren = mappingParam.children.filter((entity) => entity.checked);
    if (!enabledChildren.length) {
      setScale(0);
    } else {
      let maxScale = 0;
      // Get max scale from all enabled sizes and their enabled shanks
      if(param === 'shape') {
        maxScale = Math.max(
          ...enabledChildren.flatMap((entity) => {
          const sizeConfig = paramConfig?.sizes.find((s) => s.size_sku === entity?.sku);
          const enabledShanks = entity.children.filter(shank => shank.checked);
          return enabledShanks.map(shank => {
            const shankConfig = sizeConfig?.shanks.find(s => s.shank_sku === shank.sku);
            return shankConfig?.config[configSwitchLabel].scale || 0;
          });
        })
      )
      }else {
        maxScale = Math.max(
          ...enabledChildren.map((width) => {
            const widthConfig = paramConfig?.[width.sku_code]?.config[configSwitchLabel];
            return widthConfig?.scale || 0;
          })
        );
      }
      setScale(maxScale);
    }
  }, [mappingParam, paramConfig, scale, configSwitchLabel]);

  const handleChange = (_, newValue, event) => {
    event?.stopPropagation();
    const id = param === 'shape' ? mappingParam.id : mappingParam.sku_code;

    // Calculate the absolute difference
    const difference = newValue - scale;

    // Apply the absolute difference to all enabled sizes
    onScaleChange(id, difference, event);
    setScale(newValue);
  };

  return (
    <div className={classes.relativeScaleSection} onClick={(e) => e?.stopPropagation()}>
      <Typography variant="body2" className={classes.relativeScaleLabel}>
        Relative Scale
      </Typography>
      <div className={classes.sliderWrapper}>
        <Slider
          value={scale || 0}
          onChange={handleChange}
          min={-50}
          max={50}
          step={1}
          disabled={disabled}
          valueLabelDisplay="auto"
          valueLabelFormat={getValueLabelFormat}
        />
      </div>
      <Typography variant="body2" className={classes.scaleBadge}>
        {getValueLabelFormat(scale)}
      </Typography>
    </div>
  );
};

export default RelativeScaleSlider;
